import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-item-carousel',
  templateUrl: './item-carousel.component.html',
  styleUrls: ['./item-carousel.component.css']
})
export class ItemCarouselComponent implements OnInit {
@Input('item') item:any;
  constructor() { }

  ngOnInit(): void {
  }

}
